import React from "react";
import Alert from "@material-ui/lab/Alert";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import InfoIcon from "@material-ui/icons/Info";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import useStyles from "./TabAlert.styles";

const iconMapping = {
  warning: <ReportProblemIcon fontSize="inherit" />,
  info: <InfoIcon fontSize="inherit" />,
  error: <ErrorIcon fontSize="inherit" />,
  success: <CheckCircleIcon fontSize="inherit" />,
};

export default function TabAlert({ severity = "info", message }) {
  const classes = useStyles();

  if (!message) return null;

  return (
    <Alert
      className={classes.alert}
      classes={{
        message: classes.message,
        outlinedWarning: classes.outlinedWarning,
        outlinedInfo: classes.outlinedInfo,
        outlinedError: classes.outlinedError,
      }}
      variant="outlined"
      severity={severity}
      iconMapping={iconMapping}
    >
      {message}
    </Alert>
  );
}
